var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.languages,"rules":_vm.rules,"placeholder":"Search languages...","item-text":"label","item-value":"value","label":_vm.label,"required":_vm.required,"multiple":"","chips":"","small-chips":"","deletable-chips":""},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }